import BigNumber from 'bignumber.js'

export default {
    data() {
        return {
            chosenBandwidthValue: null,
            bandwidthChoices: [
                {
                    value: '4.54kHz',
                    spacing: 0.00625,
                    deprecated: true,
                },
                {
                    value: '7.28kHz',
                    spacing: 0.0125,
                    deprecated: false,
                },
                {
                    value: '11.8kHz',
                    spacing: 0.025,
                    deprecated: false,
                },
            ],
        }
    },

    computed: {
        chosenBandwidth() {
            return this.chosenBandwidthValue !== null
                ? this.bandwidthChoices.find(({ value }) => value === this.chosenBandwidthValue)
                : null
        },
    },

    methods: {
        channelHasBadSpacing(compareFromChannel) {
            if (this.chosenBandwidth) {
                const allChannels = this.controlChannels.concat(this.dataChannels)
                const channelFrequency = new BigNumber(compareFromChannel.frequency)
                for (let i = 0; i < allChannels.length; i++) {
                    const compareToChannel = allChannels[i]
                    if (compareFromChannel !== compareToChannel) {
                        const difference = Math.abs(
                            channelFrequency.minus(new BigNumber(compareToChannel.frequency)).toFixed()
                        )
                        const isTooClose = difference < this.chosenBandwidth.spacing
                        const isEqualAcrossTypes = compareFromChannel.type !== compareToChannel.type && difference === 0
                        if (isTooClose && !isEqualAcrossTypes) {
                            return true
                        }
                    }
                }
            }

            return false
        },

        anyChannelHasBadSpacing() {
            const allChannels = this.controlChannels.concat(this.dataChannels)
            for (let i = 0; i < allChannels.length; i++) {
                if (this.channelHasBadSpacing(allChannels[i])) {
                    return true
                }
            }
            return false
        },
    },
}
